import React, { Component } from "react";
import { Sidebar } from "primereact/sidebar";
import UpFile from "./../UpFile";
import { Message } from "primereact/message";
import { Panel } from "primereact/panel";
import "primeicons/primeicons.css";
import Server from "./../Server.js";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { SelectButton } from "primereact/selectbutton";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { confirmAlert } from "react-confirm-alert";
import { connect } from "react-redux";
import { Loader } from "rsuite";
import { MultiSelect } from "primereact/multiselect";
import { Toast } from "primereact/toast";
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';

class Company_Request extends Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    this.toast = React.createRef();
    this.CreateForm = this.CreateForm.bind(this);
    this.onHideFormsDialog = this.onHideFormsDialog.bind(this);
    this.SetReq = this.SetReq.bind(this);
    this.SetAnswer = this.SetAnswer.bind(this);
    this.GetReq = this.GetReq.bind(this);
    this.DelReq = this.DelReq.bind(this);
    this.selectedComponentChange = this.selectedComponentChange.bind(this);
    this.state = {
      name: "",
      FId: "",
      DbTableName: "",
      DBTableField: "",
      latinName: "",
      IntroducedPrice: "",
      creditAmount: "",
      users: [],
      debtorAmount: "",
      CodeFile: [],
      type: "1",
      edit: false,
      mySystem: {},
      permition: [],
      selectedRecord: {},
      SendToArray: [],
      Filter: "all",
      isMobile: false,
      RequestReciever: [],
      RequestRecieverCopy:[],
      
    };
  }

  componentDidMount() {
    if (window.innerWidth <= 768) {
      this.setState({
        isMobile: true,
      });
    }
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      that.setState({
        user_Id: response.data.authData.userId,
        user: response.data.authData.name,
        username: response.data.authData.username,
        shopId: response.data.authData.shopId,
        loading: 0,
      });
      that.Server.send(
        "AdminApi/ShopInformation",
        { ShopId: response.data.authData.shopId },
        function (response2) {
          that.setState({
            isMainShop: response2.data.result[0]?.main,
            tokenId: response2.data.result[0]?.tokenId,
          });
          that.getManagerSystemInfo();
        },
        function (error) {}
      );
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack);
  }

  getPermition() {
    let param = {
      token: localStorage.getItem("api_token"),
      userId: this.state.user_Id,
      systemId: this.props.systemId
    };

    this.setState({
      loading: 1,
    });
    let that = this;
    let SCallBack = function (response) {
      const permition =
        response.data.result[0] && response.data.result[0].permitions["155"]
          ? response.data.result[0].permitions["155"]
          : [];
      that.setState({
        loading: 0,
        permition: permition,
      },()=>{
      that.GetMaps(); 
      that.GetUsers();
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/getPermition", param, SCallBack, ECallBack);
  }
  getManagerSystemInfo() {
    let that = this;
    let param = {
      user_id: this.state.user_Id,
    };
    that.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
        mySystem:
          response.data.result[0] && response.data.result[0].system[0]
            ? response.data.result[0].system[0]
            : { subSystem: false },
      });
      that.getSystems();
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      that.getSystems();
    };
    this.Server.send(
      "MainApi/getManagerSystemInfo",
      param,
      SCallBack,
      ECallBack
    );
  }
  getSystems() {
    let that = this;
    let SCallBack = function (response) {
      let systemId = [];
      if (response.data.result) {
        for (let i = 0; i < response.data.result.length; i++) {
          systemId.push({
            value: response.data.result[i]._id,
            name: response.data.result[i].name,
          });
        }
      }
      that.setState({
        systems: systemId,
        managerSystem:
          that.state.mySystem && that.state.mySystem._id
            ? that.state.mySystem._id
            : response.data.result[0]
            ? response.data.result[0]._id
            : null,
      });
      that.getMyUnit();
    };
    let ECallBack = function (error) {
      that.getMyUnit();
    };
    this.Server.send("MainApi/getSystems", {}, SCallBack, ECallBack);
  }
  getMyUnit() {
    let that = this;
    let SCallBack = function (response) {
      let ids = [],
        fathers = [];
      for (let i = 0; i < response.data.result.length; i++) {
        ids.push(response.data.result[i]._id);
        fathers.push(response.data.result[i].father);
      }
      that.setState({
        unitFather: fathers,
        unitId: ids,
      });
      that.getCodes(["4"]);
      that.getPermition();
    };
    let ECallBack = function (error) {
      that.getCodes(["4"]);
    };
    this.Server.send(
      "AdminApi/getUnitsList",
      {
        condition: {
          usersList: { $elemMatch: { username: this.state.username } },
        },
      },
      SCallBack,
      ECallBack
    );
  }
  getUnit(All) {
    let that = this;
    let condition = {};
    const getAllUser = this.state.permition
    .some((item)=>{ return item === 16 });
    this.Server.send(
      "AdminApi/getUnitsList",
      All ? {} : { unitFather: this.state.unitFather, _id: this.state.unitId },
      (response) => {
        let SendToArray = that.state.SendToArray;
        let users = [];
        for (let i = 0; i < response.data.result.length; i++) {
          if(!All){
            SendToArray.push({
              value: response.data.result[i]._id,
              desc: response.data.result[i].fTitle,
            });
          }
          for (let j = 0; j < response.data.result[i].usersList.length; j++) {
            users.push(response.data.result[i].usersList[j].username);
          }
        }
        that.setState({
            Units: response.data.result,
            SendToArray: SendToArray,
            ShowLoading: false,
        });
        if(getAllUser && !All){
          this.getUnit(true)
        }else{
          that.GetUserOfMaps(users);
        }
        
        //users
      },
      (error) => {
        that.setState({
          ShowLoading: false,
        });
      }
    );
    this.setState({
      ShowLoading: true,
    });
  }
  GetUserOfMaps(users) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      system: this.state.managerSystem,
      users: users,
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        users: response.data.result,
      });
      that.setState({
        loading: 0,
      });
      that.GetReq();
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
      that.GetReq();
    };
    this.Server.send("AdminApi/GetUserOfMaps", param, SCallBack, ECallBack);
  }
  SetReq() {
    let that = this;
    if (!this.state.title) {
      this.toast.current.show({
        severity: "warn",
        summary: <div>موضوع درخواست را مشخص کنید</div>,
        life: 8000,
      });
      return;
    }
    if (
      this.state.RequestReciever.length === 0 &&
      !this.state.SelectedUnit &&
      this.state.map != "مشتریان"
    ) {
      this.toast.current.show({
        severity: "warn",
        summary: <div>گیرنده درخواست را مشخص کنید</div>,
        life: 8000,
      });
      return;
    }
    if (this.state.RequestReciever.indexOf(this.state.username) != -1) {
      this.toast.current.show({
        severity: "warn",
        summary: <div>نمیتوانید درخواست را به خودتان ارجاع دهید !</div>,
        life: 8000,
      });
      return;
    }
    if (!this.state.desc) {
      this.toast.current.show({
        severity: "warn",
        summary: <div>توضیحی برای درخواست ثبت کنید</div>,
        life: 8000,
      });
      return;
    }
    if (!this.state.RequestPriority) {
      this.toast.current.show({
        severity: "warn",
        summary: <div>اولویت درخواست را مشخص کنید</div>,
        life: 8000,
      });
      return;
    }
    let RequestReciever = [];
    if (this.state.SelectedUnit) {
      if (this.state.SelectedUnit === "allUsers") {
        RequestReciever = this.state.allUsers.filter((item) => {
          return this.state.username != item;
        });
      } else {
        for (let unit of this.state.Units) {
          if (
            unit._id == this.state.SelectedUnit ||
            this.state.SelectedUnit === "all"
          ) {
            for (let user of unit.usersList) {
              if (this.state.username != user.username)
                RequestReciever.push(user.username);
            }
          }
        }
      }
    } else {
      RequestReciever =  this.state.RequestReciever;
    }
    let RequestRecieverCopy = [];
    if (this.state.copy && this.state.SelectedUnitCopy) {
      for (let unit of this.state.Units) {
        if (
          unit._id == this.state.SelectedUnitCopy ||
          this.state.SelectedUnitCopy === "all"
        ) {
          for (let user of unit.usersList) {
            if (this.state.username != user.username)
              RequestRecieverCopy.push(user.username);
          }
        }
      }
    } else if(this.state.copy) {
      RequestRecieverCopy = this.state.RequestRecieverCopy;
    }
    let param = {
      desc: this.state.desc,
      attach: this.state.attach,
      title: this.state.title,
      Priority: this.state.RequestPriority,
      Reciever: RequestReciever,
      RecieverCopy: RequestRecieverCopy,
      Unit:
        this.state.SelectedUnit &&
        this.state.SelectedUnit != "all" &&
        this.state.SelectedUnit != "allUsers"
          ? this.state.SelectedUnit
          : null,
      Sender: this.state.username,
      Copy: this.state.RequestRecieverMulti,
      tokenId: this.state.tokenId,
      system: this.state.managerSystem,
      status: 1,
    };
    this.setState({
      loading: 1,
    });
    this.setState({
      HasErrorForMaps: null,
    });
    let SCallBack = function (response) {
      if (response.data.error) {
        that.setState({
          loading: 0,
        });
        that.toast.current.show({
          severity: "warn",
          summary: "",
          detail: response.data.error[0],
          life: 3000,
        });
        return;
      }
      that.onHideFormsDialog();
      that.GetReq();
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "success",
        summary: "",
        detail: "عملیات با موفقیت انجام شد",
        life: 3000,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
      that.toast.current.show({
        severity: "error",
        summary: "خطای سرور",
        detail: "عملیات انجام نشد",
        life: 5000,
      });
    };
    this.Server.send("CompanyApi/setRequest", param, SCallBack, ECallBack);
  }
  CreateForm() {
    this.setState({
      visibleAddTicket: true,
      desc: "",
      attach: "",
      title: "",
      RequestPriority: "",
      RequestReciever: "",
      type: "",
      _id: null,
    });
  }
  onHideFormsDialog(event) {
    this.setState({
      visibleAddTicket: false,
    });
  }
  selectedComponentChange(value) {
    this.setState({
      visibleAddAnswer: true,
      RequestRecieverForAnswer: "",
      SelectedUnitForAnswer: "",
      attachForAnswer: "",
      descForAnswer: "",
      selectedId: value._id,
      selectedNum: value.number,
      selectedRecord: value,
    });
    this.GetAnswer(value);
  }

  SetAnswer() {
    let that = this;
    if (!this.state.descForAnswer) {
      this.toast.current.show({
        severity: "warn",
        summary: <div>مقداری برای پاسخ ثبت کنید</div>,
        life: 8000,
      });
      return;
    }
    that.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
        visibleAddAnswer: false,
      });
      that.GetReq();
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
    };
    let param = {};
    if (
      this.state.changeSender &&
      (this.state.RequestRecieverForAnswer || this.state.SelectedUnitForAnswer)
    ) {
      let RequestReciever = [];
      if (this.state.SelectedUnitForAnswer) {
        for (let unit of this.state.Units) {
          if (unit.lTitle == this.state.SelectedUnitForAnswer) {
            for (let user of unit.usersList) {
              RequestReciever.push(user.username);
            }
          }
        }
      } else {
        RequestReciever = this.state.RequestRecieverForAnswer;
      }
      param = {
        id: this.state.selectedId,
        number: this.state.selectedNum,
        tokenId: this.state.tokenId,
        answer: this.state.descForAnswer,
        attach: this.state.attachForAnswer,
        username: this.state.username,
        Sender: this.state.username,
        Reciever: RequestReciever,
        changeSender: 1,
        draft: this.state.draft,
        firstReciever: !this.state.Reciever ? this.state.username : null,
      };
    } else {
      let Reciever = this.state.Reciever;
      param = {
        id: this.state.selectedId,
        number: this.state.selectedNum,
        tokenId: this.state.tokenId,
        answer: this.state.descForAnswer,
        attach: this.state.attachForAnswer,
        username: this.state.username,
        Sender: this.state.username,
        Reciever: Reciever,
        draft: this.state.draft,
        firstReciever: !this.state.Reciever ? this.state.username : null,
      };
    }
    if (this.state.final) param["Reciever"] = this.state.OriginalSender;

    if (!Array.isArray(param["Reciever"]))
      param["Reciever"] = [param["Reciever"]];
    this.Server.send("CompanyApi/SetAnswer", param, SCallBack, ECallBack);
  }
  GetUsers() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      GetAll: 1,
    };
    let SCallBack = function (response) {
      that.setState({
        allUsers: response.data.result.map(function (v, i) {
          return v.username;
        }),
      });
    };
    let ECallBack = function (error) {
      console.log(error);
    };
    this.Server.send("AdminApi/getuser", param, SCallBack, ECallBack);
  }
  GetAnswer(item) {
    let item_1 = item.request ? item.request[0] : item;
    let that = this;
    this.setState({
      loading: 1,
      selectedId: item_1._id,
      Sender: item_1.Sender,
      Reciever: item.sender[0].username === this.state.username ? item.reciever[0].username : item.sender[0].username,
      OriginalSender: item_1.OriginalSender,
      changeSender: false,
      desc: "",
      draft: false,
    });
    let SCallBack = function (response) {
      that.setState({
        request_details: response.data.result,
        loading: 0,
      });
      for (let i = 0; i < response.data.result.length; i++) {
        if (
          response.data.result[i].draft &&
          that.state.username == response.data.result[i].Sender
        ) {
          that.setState({
            attachForAnswer: response.data.result[i].attach,
            descForAnswer: response.data.result[i].answer,
            draft: true,
          });
        }
      }
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
    };
    this.Server.send(
      "CompanyApi/getRequestDetail",
      {
        selectedId: item_1._id,
        tokenId: this.state.tokenId,
        user: this.state.username,
      },
      SCallBack,
      ECallBack
    );
  }
  GetReq(reqNumber, Filter) {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      username: this.state.username,
      tokenId: this.state.tokenId,
      limit: 10,
      reqNumber: reqNumber,
      system: this.state.managerSystem,
      Filter: Filter || this.state.Filter,
    };
    this.setState({
      loading: 1,
      visibleAddTicket: false,
    });
    let SCallBack = function (response) {
      for (let i = 0; i < response.data.result.length; i++) {
        response.data.result[i].radif = "" + (i + 1);
        response.data.result[i].OrgSenderName =
          response.data.result[i].OriginalSender[0]?.name;
        response.data.result[i].SenderName =
        response.data.result[i].OriginalSender[0] && response.data.result[i].OriginalSender[0].name !=
          response.data.result[i].sender[0].name
            ? response.data.result[i].sender[0].name
            : "-";
        if (response.data.result[i].unitData.length > 0) {
          response.data.result[i].UnitName =
            response.data.result[i].unitData[0].fTitle;
          response.data.result[i].ReciverName = "-";
        } else {
          response.data.result[i].ReciverName = response.data.result[
            i
          ].reciever.map((iii) => {
            return <div>{iii.name}</div>;
          });
          response.data.result[i].UnitName = "-";
        }
      }
      that.setState({
        GridData: response.data.result,
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("CompanyApi/getRequest", param, SCallBack, ECallBack);
  }
  EndReq(_id, currentStatus) {
    this.setState({
      visibleAddTicket: false,
    });
    confirmAlert({
      title: <span className="yekan">تغییر وضعیت</span>,
      message: <span className="yekan"> وضعیت درخواست تغییر کند ؟ </span>,
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              _id: _id,
              End: 1,
              currentStatus: currentStatus,
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0,
                visibleAddAnswer: false,
              });
              that.GetReq();
              that.toast.current.show({
                severity: "success",
                summary: "",
                detail: "عملیات با موفقیت انجام شد",
                life: 3000,
              });
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0,
              });
              that.toast.current.show({
                severity: "error",
                summary: "خطای سرور",
                detail: "عملیات انجام نشد",
                life: 5000,
              });
            };
            this.Server.send(
              "CompanyApi/setRequest",
              param,
              SCallBack,
              ECallBack
            );
          },
        },
        {
          label: <span className="yekan">خیر </span>,
        },
      ],
    });
  }
  DelReq(_id) {
    this.setState({
      visibleAddTicket: false,
    });
    confirmAlert({
      title: <span className="yekan">حذف ردیف</span>,
      message: <span className="yekan"> آیا از حذف مطمئنید </span>,
      buttons: [
        {
          label: <span className="yekan">بله </span>,
          onClick: () => {
            let that = this;
            let param = {
              token: localStorage.getItem("api_token"),
              _id: _id,
              del: 1,
            };
            let SCallBack = function (response) {
              that.setState({
                loading: 0,
              });
              that.GetReq();
              that.toast.current.show({
                severity: "success",
                summary: "",
                detail: "عملیات با موفقیت انجام شد",
                life: 3000,
              });
            };
            let ECallBack = function (error) {
              that.setState({
                loading: 0,
              });
              that.toast.current.show({
                severity: "error",
                summary: "خطای سرور",
                detail: "عملیات انجام نشد",
                life: 5000,
              });
            };
            this.Server.send(
              "CompanyApi/setRequest",
              param,
              SCallBack,
              ECallBack
            );
          },
        },
        {
          label: <span className="yekan">خیر </span>,
        },
      ],
    });
  }
  getCodes(id) {
    let that = this;
    that.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        CodeFile: response.data.result,
        loading: 0,
      });
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0,
      });
      console.log(error);
    };
    this.Server.send("AdminApi/GetCodes", { id: id }, SCallBack, ECallBack);
  }
  GetMaps() {
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
      mobile: this.state.username,
      user_Id: this.state.userId,
      systemId : this.props.systemId,
      Key: "username",
    };
    this.setState({
      loading: 1,
    });
    let SCallBack = function (response) {
      that.setState({
        loading: 0,
        map: response.data.result[0].map,
      });
      that.getUnit();
    };
    let ECallBack = function (error) {
      console.log(error);
      that.setState({
        loading: 0,
      });
    };
    this.Server.send("MainApi/getUserData", param, SCallBack, ECallBack);
  }
  renderListItem = (data) => {
    const statusTemplate =  data.status != 0 ? (
      data.read == 0 ||
      (data.details &&
        data.details.some((item) => {
          return item.read == 0;
        })) ? (
        <span>
          <i
            className="far fa-eye-slash"
            style={{ color: "red", fontSize: 16 }}
          />
        </span>
      ) : (
        <span>
          <i
            className="far fa-eye"
            style={{ color: "green", fontSize: 16 }}
          />
        </span>
      )
    ) : (
      <span>بایگانی</span>
    );
    return (
      <div onClick={()=>{
          this.selectedComponentChange(data)
        }} style={{border:'1px solid rgb(150,150,150)',borderRadius:6}} className="mb-3">
                <div style={{display:'flex',padding:5, borderTopLeftRadius:6,borderTopRightRadius:6, justifyContent:"space-between",color:"#fff",background:'rgb(5,182,213)'}}>
                    <span style={{width:'10%',fontSize:12}}>شماره</span>
                    <span style={{width:'40%',fontSize:12}}>موضوع</span>
                    <span style={{width:'25%',fontSize:12}}>فرستنده</span>
                    <span style={{width:'25%',fontSize:12}}>تاریخ</span>

                </div>
                <div style={{display:'flex', justifyContent:"space-between", padding: 5, fontWeight:'bold'}}>
                    <span className="ellipsis2" style={{width:'10%',paddingRight:4,whiteSpace:'nowrap',fontSize:12}}>{data.number}</span>
                    <span className="ellipsis2"  style={{width:'40%',paddingRight:4,whiteSpace:'nowrap',fontSize:13}}>{data.title}</span>
                    <span className="ellipsis2"  style={{width:'25%',paddingRight:4,whiteSpace:'nowrap',fontSize:12}}>{data.OrgSenderName}</span>
                    <span className="ellipsis2"  style={{width:'25%',paddingRight:4,whiteSpace:'nowrap',fontSize:12}}>{data.Date}</span>
                </div>
        </div>
       
                // <div onClick={()=>{
                //     this.selectedComponentChange(data)
                //   }} style={{display:'flex', justifyContent:"space-between", padding: 5, fontWeight:'bold'}}>
                //     <span className="ellipsis2" style={{width:'4%',paddingRight:4,whiteSpace:'nowrap'}}>{data.number}</span>
                //     <span className="ellipsis2"  style={{width:'30%',paddingRight:4,whiteSpace:'nowrap'}}>{data.title}</span>
                //     <span className="ellipsis2"  style={{width:'15%',paddingRight:4,whiteSpace:'nowrap'}}>{data.OrgSenderName}</span>
                //     <span className="ellipsis2"  style={{width:'15%',paddingRight:4,whiteSpace:'nowrap'}}>{data.SenderName}</span>
                //     <span className="ellipsis2"  style={{width:'15%',paddingRight:4,whiteSpace:'nowrap'}}>{data.Reciever}</span>
                //     <span className="ellipsis2"  style={{width:'7%',paddingRight:4,whiteSpace:'nowrap'}}>{data.Priority}</span>
                //     <span className="ellipsis2"  style={{width:'7%',paddingRight:4,whiteSpace:'nowrap'}}>{data.Date}</span>
                //     <span className="ellipsis2"  style={{width:'7%',paddingRight:4,whiteSpace:'nowrap'}}>{data.Time}</span>
                //     <span className="ellipsis2"  style={{width:'7%',paddingRight:4,whiteSpace:'nowrap'}}>{statusTemplate}</span>

                // </div>
    );
}
  render() {
    
    const FilterItems = [
      {
        label: (
          <span style={{ fontSize: this.state.isMobile ? 12 : "unset" }}>
            همه
          </span>
        ),
        value: "all",
      },
      {
        label: (
          <span style={{ fontSize: this.state.isMobile ? 12 : "unset" }}>
            دریافت شده
          </span>
        ),
        value: "recieved",
      },
      {
        label: (
          <span style={{ fontSize: this.state.isMobile ? 12 : "unset" }}>
            ارسال شده
          </span>
        ),
        value: "sender",
      },
      {
        label: (
          <span style={{ fontSize: this.state.isMobile ? 12 : "unset" }}>
            رونوشت ها
          </span>
        ),
        value: "copy",
      },
      {
        label: (
          <span style={{ fontSize: this.state.isMobile ? 12 : "unset" }}>
            بایگانی ها
          </span>
        ),
        value: "archive",
      },
    ];
    const footer = (
      <div>
        <button
          className="btn btn-primary irsans"
          onClick={this.SetReq}
          disabled={this.state.loading}
          style={{ width: "200px", marginTop: "20px", marginBottom: "20px" }}
        >
          ثبت درخواست
        </button>
      </div>
    );

    const ReciverTemplate = (rowData, props) => {
      return rowData.UnitName != "-" ? (
        <span className="ellipsis">{rowData.UnitName}</span>
      ) : (
        <span className="ellipsis">{rowData.ReciverName}</span>
      );
    };
    const statusTemplate = (rowData, props) => {
      return rowData.status != 0 ? (
        rowData.read == 0 ||
        (rowData.details &&
          rowData.details.some((item) => {
            return item.read == 0;
          })) ? (
          <span>
            <i
              className="far fa-eye-slash"
              style={{ color: "red", fontSize: 16 }}
            />
          </span>
        ) : (
          <span>
            <i
              className="far fa-eye"
              style={{ color: "green", fontSize: 16 }}
            />
          </span>
        )
      ) : (
        <span>بایگانی</span>
      );
    };
    const attachTemplate = (rowData, props) => {
      return rowData.attach ? (
        <a href={rowData.attach} className="yekan" target="_blank">
          <i className="fa fa-paperclip" style={{ paddingLeft: 5 }} />
        </a>
      ) : (
        <span>-</span>
      );
    };

    return (
      <div style={{ direction: "rtl" }}>
        {this.state.loading == 1 && (
          <div
            style={{
              position: "fixed",
              zIndex: 2000,
              top: 10,
              left: 15,
              backgroundColor: "#e89f31",
              padding: "2px 20px",
            }}
          >
            <Loader content="لطفا صبر کنید ..." className="yekan" />
          </div>
        )}
        <div className="row justify-content-center">
          <Toast
            ref={this.toast}
            position="top-left"
            style={{ fontFamily: "YekanBakhFaBold", textAlign: "right" }}
          />

          <div className="col-12" style={{ background: "#fff" }}>
            <div className="row">
              <div className="col-12" style={{ background: "#fff" }}>
                <div style={{ textAlign: "right" }}>
                  <button
                    className="btn btn-info irsans"
                    onClick={this.CreateForm}
                    style={{
                      width: "200px",
                      marginTop: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    ثبت درخواست جدید
                  </button>
                </div>
                <div className="datatable-doc-demo">
                  <div className="card p-3">
                    <div
                      style={{
                        textAlign: "right",
                        marginBottom: 10,
                        marginTop: 20,
                      }}
                    >
                      <SelectButton
                        value={this.state.Filter}
                        options={FilterItems}
                        style={{
                          fontFamily: "Yekan",
                        }}
                        className="yekan sarv-tickets sarv-selectBotten"
                        onChange={(e) => {
                          if (e.value != null) {
                            this.setState({ Filter: e.value });
                            this.GetReq(null, e.value);
                          }
                        }}
                      ></SelectButton>
                    </div>
                      {this.state.isMobile ?
                      <DataView value={this.state.GridData} 
                      itemTemplate={this.renderListItem}  />
                      :
                      <DataTable
                      value={this.state.GridData}
                      selectionMode="single"
                      selection={this.state.selectedComponent}
                      onSelectionChange={(e) =>
                        this.selectedComponentChange(e.value)
                      }
                      className="datatable-sarv"
                    >
                      <Column
                        field="radif"
                        header="ردیف"
                        className="irsans"
                        style={{ textAlign: "right", width: 60 }}
                      />
                      <Column
                        field="number"
                        header="شماره نامه"
                        sortable
                        className="irsans"
                        style={{ textAlign: "right", width: 80 }}
                      />
                      <Column
                        field="title"
                        header="موضوع"
                        className="irsans"
                        style={{ textAlign: "right", width: 300 }}
                      />
                      <Column
                        field="OrgSenderName"
                        header="فرستنده"
                        sortable
                        className="irsans"
                        style={{ textAlign: "right", width: 120 }}
                      />
                      <Column
                        field="SenderName"
                        header="ارجاع دهنده"
                        sortable
                        className="irsans"
                        style={{ textAlign: "right", width: 120 }}
                      />
                      <Column
                        field="Reciever"
                        header="واحد / گیرنده"
                        sortable
                        className="irsans"
                        style={{ textAlign: "right", width: 120 }}
                        body={ReciverTemplate}
                      />
                      <Column
                        field="Priority"
                        header="اولویت"
                        className="irsans"
                        sortable
                        style={{ textAlign: "right", width: 80 }}
                      />
                      <Column
                        field="Date"
                        header="تاریخ"
                        className="irsans"
                        style={{ textAlign: "right", width: 120 }}
                      />
                      <Column
                        field="Time"
                        header="ساعت"
                        className="irsans"
                        style={{ textAlign: "right", width: 120 }}
                      />
                      <Column
                        field="Status"
                        header="مشاهده"
                        sortable
                        body={statusTemplate}
                        className="irsans"
                        style={{ textAlign: "right", width: 100 }}
                      />
                      <Column
                        field="attach"
                        header="ضمیمه"
                        body={attachTemplate}
                        className="irsans"
                        style={{ textAlign: "right", width: 100 }}
                      />
                    </DataTable>
                      } 
                  </div>
                </div>
              </div>
            </div>

            <Dialog
              style={{ width: this.state.isMobile ? "auto" : "60vw" }}
              header={this.state.selectedId ? "اصلاح" : "ثبت درخواست"}
              visible={this.state.visibleAddTicket}
              footer={footer}
              onHide={this.onHideFormsDialog}
              maximizable={true}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: this.state.isMobile ? "wrap" : "nowrap",
                }}
              >
                <div style={{ alignItems: "center" }}>
                  <div className="col-lg-6">
                    <div className="group">
                      <input
                        className="form-control irsans"
                        autoComplete="off"
                        type="text"
                        value={this.state.title}
                        style={{ width: 300 }}
                        name="title"
                        onChange={(event) =>
                          this.setState({ title: event.target.value })
                        }
                        required="true"
                      />
                      <label>
                        موضوع {this.state.type == "1" ? "درخواست" : "پیام"}
                      </label>
                    </div>
                  </div>
                  {this.state.map != "مشتریان" && (
                    <div className="col-lg-12">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <label className="labelNoGroup irsans">واحد</label>
                        <select
                          placeholder=""
                          style={{ width: 300 }}
                          disabled={this.state.RequestReciever.length !== 0}
                          className="form-control iranyekanwebmedium"
                          id={this.state.SelectedUnit}
                          name="SelectedUnit"
                          value={this.state.SelectedUnit}
                          onChange={(event) => {
                            this.setState({ SelectedUnit: event.target.value });
                          }}
                        >
                          <option value=""></option>
                          {this.state.SendToArray &&
                            this.state.SendToArray.map((item, index) => {
                              return (
                                <option value={item.value}>{item.desc}</option>
                              );
                            })}
                          {this.state.permition.some((item) => {
                            return item == 1;
                          }) && (
                            <option value="all" style={{ color: "red" }}>
                              ارسال به واحدهای زیر مجموعه
                            </option>
                          )}
                          {this.state.permition.some((item) => {
                            return item == 1;
                          }) && (
                            <option value="allUsers" style={{ color: "red" }}>
                              ارسال به همه کاربران
                            </option>
                          )}
                        </select>
                      </div>
                    </div>
                  )}
                  {this.state.map != "مشتریان" && (
                    <div className="col-lg-12 mt-2">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <label className="labelNoGroup irsans">گیرنده</label>
                        <MultiSelect
                              value={this.state.RequestReciever}
                              optionLabel="name"
                              style={{ width: "100%",maxWidth:300 }}
                              optionValue="username"
                              options={this.state.users}
                              onChange={(event) => {
                                this.setState({RequestReciever: event.value });
                              }}
                              disabled={this.state.SelectedUnit}

                         />
                       
                      </div>
                    </div>
                  )}

                  {this.state.CodeFile.map((v, i) => {
                    //this.setState({ [v.Etitle]: v.values[0].value });
                    return (
                      <div className="col-lg-12 mt-2">
                        {v.MultiSelect ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "baseline",
                            }}
                          >
                            <p
                              className="yekan"
                              style={{ textAlign: "right", paddingRight: 10 }}
                            >
                              {v.title}
                            </p>
                            <MultiSelect
                              value={this.state[v.Etitle]}
                              optionLabel="desc"
                              style={{ width: "100%" }}
                              optionValue="value"
                              options={v.values}
                              onChange={(event) => {
                                this.setState({ [v.Etitle]: event.value });
                              }}
                            />
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <label className="labelNoGroup irsans">
                              {v.title}
                            </label>
                            <select
                              className="form-control irsans"
                              style={{ width: 300 }}
                              value={this.state.RequestPriority}
                              onChange={(event) => {
                                this.setState({
                                  RequestPriority: event.target.value,
                                });
                              }}
                            >
                              <option value=""></option>
                              {v.values.map(function (u, j) {
                                return (
                                  <option value={u.value}>{u.desc}</option>
                                );
                              })}
                            </select>
                          </div>
                        )}
                      </div>
                    );
                  })}

                  {this.state.users.length > 0 &&
                    this.state.permition.some((item) => {
                      return item == 8;
                    }) && (
                      <div
                        className="col-lg-12 mt-2"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          alignItems: "flex-start",
                        }}
                      >
                        <Checkbox
                          inputId="copy"
                          value={this.state.copy}
                          checked={this.state.copy}
                          onChange={(e) => this.setState({ copy: e.checked })}
                        ></Checkbox>
                        <label
                          htmlFor="copy"
                          className="p-checkbox-label yekan"
                          style={{ paddingRight: 5 }}
                        >
                          {" "}
                          رونوشت به :
                        </label>
                      </div>
                    )}

                  {this.state.copy && (
                    <div className="col-lg-12">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <label className="labelNoGroup irsans">واحد</label>
                        <select
                          placeholder=""
                          style={{ width: 300 }}
                          disabled={this.state.RequestRecieverCopy.length !== 0}
                          className="form-control iranyekanwebmedium"
                          id={this.state.SelectedUnitCopy}
                          name="SelectedUnit"
                          value={this.state.SelectedUnitCopy}
                          onChange={(event) => {
                            this.setState({
                              SelectedUnitCopy: event.target.value,
                            });
                          }}
                        >
                          <option value=""></option>
                          {this.state.SendToArray &&
                            this.state.SendToArray.map((item, index) => {
                              return (
                                <option value={item.value}>{item.desc}</option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  )}
                  {this.state.copy && (
                    <div className="col-lg-12 mt-2">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <label className="labelNoGroup irsans">گیرنده</label>
                        <MultiSelect
                              value={this.state.RequestRecieverCopy}
                              optionLabel="name"
                              style={{ width: "100%",maxWidth:300 }}
                              optionValue="username"
                              options={this.state.users}
                              onChange={(event) => {
                                this.setState({RequestRecieverCopy: event.value });
                              }}
                              disabled={this.state.SelectedUnitCopy}

                         />
                      </div>
                    </div>
                  )}

                  <UpFile
                    label={<div style={{ textAlign: "center" }}></div>}
                    className="col-lg-12 col-12 mt-3"
                    large={true}
                    uploadImage={this.state.attach}
                    buttonLabel="ضمیمه"
                    callback={(v) => {
                      this.setState({
                        attach: v.uploadImage,
                      });
                    }}
                  />
                </div>
                <div style={{ width: "100%" }}>
                  <div className="group">
                    <textarea
                      className="form-control irsans"
                      style={{ height: 200 }}
                      autoComplete="off"
                      type="text"
                      value={this.state.desc}
                      name="desc"
                      onChange={(event) =>
                        this.setState({ desc: event.target.value })
                      }
                      required="true"
                    ></textarea>
                    <label>
                      متن {this.state.type == "1" ? "درخواست" : "پیام"}
                    </label>
                  </div>
                </div>
              </div>
            </Dialog>

            <Sidebar
              style={{ minWidth: this.state.isMobile ? "100%" : "50%" }}
              header={this.state.activeIndex == 1 ? "مشاهده" : "مشاهده و پاسخ"}
              visible={this.state.visibleAddAnswer}
              footer={footer}
              position="right"
              onHide={() => {
                this.setState({
                  visibleAddAnswer: false,
                });
                this.GetReq();
              }}
              maximizable={true}
            >
              {this.state.Filter != "copy" &&
                this.state.permition.some((item) => {
                  return item == 4;
                }) && (
                  <div>
                    {this.state.selectedRecord.status == 1 ? (
                      <button
                        className="btn btn-primary irsans"
                        onClick={() => {
                          this.EndReq(this.state.selectedRecord._id, 1);
                        }}
                        style={{
                          width: "200px",
                          marginTop: "20px",
                          marginBottom: "20px",
                        }}
                      >
                        {" "}
                        بایگانی شود{" "}
                      </button>
                    ) : (
                      <button
                        className="btn btn-primary irsans"
                        onClick={() => {
                          this.EndReq(this.state.selectedRecord._id, 0);
                        }}
                        style={{
                          width: "200px",
                          marginTop: "20px",
                          marginBottom: "20px",
                        }}
                      >
                        {" "}
                        به درخواست های جاری بازگردد{" "}
                      </button>
                    )}
                  </div>
                )}

              <div style={{ textAlign: "right" }} className="noIcon">
                <Message
                  severity="info"
                  text={this.state.selectedRecord.title}
                  style={{
                    width: "100%",
                    textAlign: "right",
                    borderRadius: 0,
                    fontWeight: "bold",
                    whiteSpace: "pre-wrap",
                  }}
                />
                <br />
                <Message
                  severity="success"
                  text={this.state.selectedRecord.desc}
                  style={{
                    width: "100%",
                    textAlign: "right",
                    borderRadius: 0,
                    fontWeight: "bold",
                    whiteSpace: "pre-wrap",
                  }}
                />

                {this.state.request_details &&
                  this.state.request_details.map((item, index) => {
                    let header = (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          fontSize: 13,
                        }}
                      >
                        <span style={{ paddingLeft: 10 }}>
                          {item.userData[0] ? item.userData[0].name : ""}
                        </span>
                        <span style={{ paddingLeft: 10 }}>{item.Date}</span>
                        <span style={{ paddingLeft: 10 }}>{item.Time}</span>
                      </div>
                    );
                    if (!item.draft) {
                      return item.user == this.state.username ||
                        this.state.activeIndex == 1 ? (
                        <Panel header={header} style={{ marginTop: 10 }}>
                          <div style={{ display: "none" }}>
                            <i
                              className="fa fa-check"
                              style={{
                                color: item.read ? "#00d000" : "gainsboro",
                              }}
                            />
                            <i
                              className="fa fa-check"
                              style={{
                                color: item.read ? "#00d000" : "gainsboro",
                              }}
                            />
                          </div>

                          <p
                            style={{
                              textAlign: "right",
                              fontSize: 15,
                              whiteSpace: "pre-wrap",
                            }}
                            className="yekan"
                          >
                            {item.answer}
                          </p>
                          {item.attach && (
                            <div
                              style={{ display: "flex", justifyContent: "end" }}
                            >
                              <a
                                href={item.attach}
                                className="yekan"
                                target="_blank"
                              >
                                <i
                                  className="fa fa-paperclip"
                                  style={{ paddingLeft: 5 }}
                                />
                                دانلود فایل ضمیمه
                              </a>
                            </div>
                          )}
                        </Panel>
                      ) : (
                        <Panel header={header} style={{ marginTop: 10 }}>
                          <p
                            style={{
                              textAlign: "right",
                              fontSize: 17,
                              backgroundColor: "#b9e4d93b",
                              padding: 20,
                              whiteSpace: "pre-wrap",
                            }}
                            className="yekan"
                          >
                            {item.answer}
                          </p>
                          {item.attach && (
                            <div
                              style={{ display: "flex", justifyContent: "end" }}
                            >
                              <a
                                href={item.attach}
                                className="yekan"
                                target="_blank"
                              >
                                <i
                                  className="fa fa-paperclip"
                                  style={{ paddingLeft: 5 }}
                                />
                                دانلود فایل ضمیمه
                              </a>
                            </div>
                          )}
                        </Panel>
                      );
                    }
                  })}
                {this.state.Filter != "copy" && (
                  <Panel
                    header={<p>پاسخ درخواست</p>}
                    style={{ marginTop: 10 }}
                    toggleable={true}
                    collapsed={false}
                  >
                    <div className="row">
                      <div className="col-md-4 col-12 mt-4 order-md-1 order-2">
                        <div className="row">
                          <div
                            className="col-12"
                            style={{
                              textAlign: "right",
                              display: "flex",
                              alignItems: "flex-start",
                            }}
                          >
                            <Checkbox
                              inputId="draft"
                              value={this.state.draft}
                              checked={this.state.draft}
                              onChange={(e) =>
                                this.setState({ draft: e.checked })
                              }
                            ></Checkbox>
                            <label
                              htmlFor="draft"
                              className="p-checkbox-label yekan"
                              style={{ paddingRight: 5 }}
                            >
                              {" "}
                              پیشنویس
                            </label>
                          </div>

                          <div
                            className="col-12"
                            style={{
                              textAlign: "right",
                              display: "flex",
                              alignItems: "flex-start",
                            }}
                          >
                            <Checkbox
                              inputId="final"
                              value={this.state.final}
                              checked={this.state.final}
                              onChange={(e) =>
                                this.setState({ final: e.checked })
                              }
                            ></Checkbox>
                            <label
                              htmlFor="final"
                              className="p-checkbox-label yekan"
                              style={{ paddingRight: 5 }}
                            >
                              {" "}
                              پاسخ نهایی به فرستنده اولیه
                            </label>
                          </div>
                          {this.state.users.length > 0 &&
                            this.state.permition.some((item) => {
                              return item == 2;
                            }) && (
                              <div
                                className="col-12"
                                style={{
                                  textAlign: "right",
                                  display: "flex",
                                  alignItems: "flex-start",
                                }}
                              >
                                <Checkbox
                                  inputId="changeSender"
                                  value={this.state.changeSender}
                                  checked={this.state.changeSender}
                                  onChange={(e) =>
                                    this.setState({ changeSender: e.checked })
                                  }
                                ></Checkbox>
                                <label
                                  htmlFor="changeSender"
                                  className="p-checkbox-label yekan"
                                  style={{ paddingRight: 5 }}
                                >
                                  {" "}
                                  ارجاع به دیگران
                                </label>
                              </div>
                            )}

                          {this.state.changeSender && (
                            <div
                              className="col-lg-12"
                              style={{ marginBottom: 20 }}
                            >
                              <label className="labelNoGroup irsans">
                                واحد
                              </label>
                              <select
                                placeholder=""
                                disabled={this.state.RequestRecieverForAnswer}
                                className="form-control iranyekanwebmedium"
                                id={this.state.SelectedUnitForAnswer}
                                name="SelectedUnitForAnswer"
                                value={this.state.SelectedUnitForAnswer}
                                onChange={(event) => {
                                  this.setState({
                                    SelectedUnitForAnswer: event.target.value,
                                  });
                                }}
                              >
                                <option value=""></option>
                                {this.state.SendToArray &&
                                  this.state.SendToArray.map((item, index) => {
                                    return (
                                      <option value={item.value}>
                                        {item.desc}
                                      </option>
                                    );
                                  })}
                                {this.state.permition.some((item) => {
                                  return item == 1;
                                }) && (
                                  <option value="all" style={{ color: "red" }}>
                                    ارسال به واحدهای زیر مجموعه
                                  </option>
                                )}
                                {this.state.permition.some((item) => {
                                  return item == 1;
                                }) && (
                                  <option
                                    value="allUsers"
                                    style={{ color: "red" }}
                                  >
                                    ارسال به همه کاربران
                                  </option>
                                )}
                              </select>
                            </div>
                          )}
                          {this.state.changeSender && (
                            <div
                              className="col-lg-12"
                              style={{ marginBottom: 20 }}
                            >
                              <div>
                                <label className="labelNoGroup irsans">
                                  ارجاع به
                                </label>
                                <select
                                  className="form-control irsans"
                                  value={this.state.RequestRecieverForAnswer}
                                  disabled={this.state.SelectedUnitForAnswer}
                                  onChange={(event) => {
                                    this.setState({
                                      RequestRecieverForAnswer:
                                        event.target.value,
                                    });
                                  }}
                                >
                                  <option value=""></option>

                                  {this.state.users.map((v, i) => {
                                    return (
                                      <option value={v.username}>
                                        {v.name}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            </div>
                          )}
                          <div>
                            <UpFile
                              className="col-lg-12 col-12 mt-3"
                              large={true}
                              uploadImage={this.state.attachForAnswer}
                              buttonLabel="انتخاب فایل"
                              callback={(v) => {
                                this.setState({
                                  attachForAnswer: v.uploadImage,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-md-8  col-12 order-md-2 order-1"
                        style={{
                          textAlign: "right",
                          display: "flex",
                          alignItems: "baseline",
                        }}
                      >
                        <div className="group" style={{ width: "100%" }}>
                          <textarea
                            className="form-control irsans"
                            autoComplete="off"
                            type="text"
                            value={this.state.descForAnswer}
                            name="desc"
                            onChange={(event) =>
                              this.setState({
                                descForAnswer: event.target.value,
                              })
                            }
                            style={{ height: 200 }}
                          ></textarea>
                          <label>پاسخ</label>
                        </div>
                      </div>
                    </div>

                    <div>
                      <button
                        className="btn btn-primary irsans"
                        onClick={this.SetAnswer}
                        disabled={this.state.loading}
                        style={{
                          width: "200px",
                          marginTop: "20px",
                          marginBottom: "20px",
                        }}
                      >
                        ثبت پاسخ
                      </button>
                    </div>
                  </Panel>
                )}
              </div>
            </Sidebar>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Company_Request);
